import { cn } from "@weco/ui";
import { COMPANION_HUES, companionPalette } from "../companionPalette";

export function HueSwatches({
  value,
  onPick,
}: {
  value: number;
  onPick: (hue: number) => void;
}) {
  return (
    <div role="radiogroup" className="flex flex-wrap gap-3">
      {COMPANION_HUES.map((hue) => {
        const isSelected = hue === value;
        const palette = companionPalette(hue);

        return (
          <button
            key={hue}
            role="radio"
            aria-checked={isSelected}
            onClick={() => onPick(hue)}
            className={cn(
              "h-12 w-12 rounded-full ring-2 transition-all",
              isSelected
                ? "ring-slate-800"
                : "ring-transparent hover:ring-slate-400/50"
            )}
            style={{
              background: `radial-gradient(circle at 35% 30%, ${palette.light}, ${palette.base} 55%, ${palette.dark})`,
            }}
            aria-label={`Hue ${hue}`}
          />
        );
      })}
    </div>
  );
}
